/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { ActivityDetails,
  CommunicationMeetingMapper,
  CommunicationDataDto,
  CommunicationListItemDto,
  CommunicationDataMapper,
  CommunicationListItemMapper,
} from '../../communications';

@Injectable()
export class JobCommunicationRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  get(jobId: ID): Observable<CommunicationDataDto> {
    return this.httpGet(
      `${this.bp}/jobs/${jobId}/communications`,
      CommunicationDataMapper,
    );
  }

  sendSms(jobId: ID, sms: CommunicationListItemDto): Observable<CommunicationListItemDto> {
    return this.httpPost(
      `${this.bp}/jobs/${jobId}/communications/send-sms`,
      sms,
      CommunicationListItemMapper,
    );
  }

  sendEmail(jobId: ID, email: CommunicationListItemDto): Observable<CommunicationListItemDto> {
    return this.httpPost(
      `${this.bp}/jobs/${jobId}/communications/send-email`,
      email,
      CommunicationListItemMapper,
    );
  }

  getMeeting(jobId: ID, meetingId: ID): Observable<ActivityDetails> {
    return this.httpGet(`${this.bp}/jobs/${jobId}/communications/meeting/${meetingId}`, CommunicationMeetingMapper);
  }

  createMeeting(jobId: ID, meeting: ActivityDetails): Observable<ActivityDetails> {
    return this.httpPost(`${this.bp}/jobs/${jobId}/communications/meeting`, meeting, CommunicationMeetingMapper);
  }

  updateMeeting(jobId: ID, meeting: ActivityDetails): Observable<ActivityDetails> {
    return this.httpPut(
      `${this.bp}/jobs/${jobId}/communications/meeting/${meeting.id}`,
      meeting,
      CommunicationMeetingMapper);
  }
}
